const keyMirror = require("keymirror");

module.exports = keyMirror({
  ACTIVE: null,
  INACTIVE: null,
});



// WEBPACK FOOTER //
// ./common/constants/statusType.js